import React from "react";
import AliadosSoluciones from "./AliadosSoluciones";

const Aliados = () => {
  return <AliadosSoluciones idTranslate={100} page="aliados"/>;
};

export default Aliados;
